export default __webpack_public_path__ + "static/room_w.f061a17aaeb3e0345c26f470874f2f72.svg";